import { createDeliveryClient } from "@kontent-ai/delivery-sdk";
import { ENVIRONMENT_ID } from "../config";

const client = createDeliveryClient({
  environmentId: ENVIRONMENT_ID,
});

const kontentService = async (contentTypeName: string) => {
  const response = await client.item(contentTypeName).toPromise();
  return response.data.item;
};

export default kontentService;
